// Pointer, wheel, touch and keyboard input for the canvas scene.
// Activation goes through the hidden DOM anchors so links stay real links.

export function attachInput(canvas, scene, { anchorFor }) {
  let drag = null;
  let swallowClick = false;

  const activate = region => {
    if (!region) return;
    if (region.action === 'scroll') {
      scene.scrollTo(region.target);
      return;
    }
    const a = anchorFor(region.id);
    if (a) a.click();
  };

  canvas.addEventListener('pointermove', e => {
    scene.setPointer(e.clientX, e.clientY, e.pointerType);
    if (drag) {
      const dy = e.clientY - drag.lastY;
      const now = performance.now();
      drag.vel = dy / Math.max(1, now - drag.lastT);
      drag.lastY = e.clientY;
      drag.lastT = now;
      drag.moved += Math.abs(dy);
      scene.dragScroll(-dy);
      if (drag.moved > 8) swallowClick = true;
    }
  });

  canvas.addEventListener('pointerleave', () => scene.setPointer(-1, -1, 'none'));

  canvas.addEventListener('pointerdown', e => {
    scene.setPointer(e.clientX, e.clientY, e.pointerType);
    if (e.pointerType === 'touch') {
      drag = { lastY: e.clientY, lastT: performance.now(), vel: 0, moved: 0 };
      swallowClick = false;
      scene.stopScroll();
      canvas.setPointerCapture(e.pointerId);
    } else {
      scene.press(e.clientX, e.clientY);
    }
  });

  const endPointer = e => {
    if (drag) {
      if (drag.moved > 8) scene.fling(-drag.vel * 1000);
      drag = null;
    }
    scene.release();
  };
  canvas.addEventListener('pointerup', endPointer);
  canvas.addEventListener('pointercancel', endPointer);

  canvas.addEventListener('click', e => {
    if (swallowClick) {
      swallowClick = false;
      return;
    }
    activate(scene.hitTest(e.clientX, e.clientY));
  });

  canvas.addEventListener(
    'wheel',
    e => {
      e.preventDefault();
      const unit = e.deltaMode === 1 ? 24 : e.deltaMode === 2 ? scene.H : 1;
      scene.scrollBy(e.deltaY * unit);
    },
    { passive: false }
  );

  window.addEventListener('keydown', e => {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    const tag = (e.target && e.target.tagName) || '';
    if (tag === 'INPUT' || tag === 'TEXTAREA') return;
    const page = scene.H * 0.85;
    switch (e.key) {
      case 'ArrowDown':
        scene.scrollBy(80);
        break;
      case 'ArrowUp':
        scene.scrollBy(-80);
        break;
      case 'PageDown':
        scene.scrollBy(page);
        break;
      case 'PageUp':
        scene.scrollBy(-page);
        break;
      case ' ':
        if (tag === 'A') return; // let a focused link keep its default
        scene.scrollBy(e.shiftKey ? -page : page);
        break;
      case 'Home':
        scene.scrollTo(0);
        break;
      case 'End':
        scene.scrollTo(Infinity);
        break;
      default:
        return;
    }
    e.preventDefault();
  });
}
